var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSimpleData)?_c('span',{class:_vm.stringifyChangelogClass},[_vm._v(" "+_vm._s(_vm.stringifyChangelog)+" ")]):_c('q-btn',{attrs:{"label":"مشاهده","color":"red","unelevated":"","flat":""},on:{"click":_vm.showModal}})}
var staticRenderFns = []

export { render, staticRenderFns }